import UIElement from '@adyen/adyen-web/dist/types/components/UIElement';
import { PaymentAction } from '@adyen/adyen-web/dist/types/types';
import { useEffect, useMemo, useRef, useState } from 'react';
import AdyenCore from '@adyen/adyen-web/dist/types/core';

interface Configuration {
  onAdditionalDetails: (state: State, component: UIElement) => void;
}

interface State {
  data: Record<string, unknown>;
}

export default function Session3DS({
  action,
  handleResult,
  adyenSdk,
}: {
  action: PaymentAction;
  handleResult: (data: Record<string, unknown>) => void;
  adyenSdk: AdyenCore;
}): JSX.Element {
  const sessionContainer = useRef<HTMLDivElement>(null);
  const [session, setSession] = useState<UIElement | null>(null);
  const configuration: Configuration = useMemo(() => {
    const handleOnAdditionalDetails = (state: State, component: UIElement) => {
      setSession(component);
      handleResult(state.data);
      //    state.data // Provides the data that you need to pass in the `/payments/details` call.
      //    component // Provides the active component instance that called this event.
    };
    return {
      onAdditionalDetails: handleOnAdditionalDetails, // Your function for handling onAdditionalDetails event
    };
  }, [setSession, handleResult]);

  useEffect(() => {
    if (sessionContainer?.current != null && session == null) {
      setSession(adyenSdk.createFromAction(action, configuration).mount(sessionContainer.current));
    }
  }, [session, action, configuration, adyenSdk]);
  return <div id="3ds-container" ref={sessionContainer}></div>;
}
